var projectTimeline = {
	"Project timeline": "프로젝트 타임라인",
	"None planned": "계획 없음",
	"1-3 months": "1~3개월",
	"4-6 months": "4~6개월",
	"7-12 months": "7~12개월",
	"More than 1 year": "1년 이상"
};

export { projectTimeline as default };
